import { createAction, props } from '@ngrx/store';
import { IComplaince } from '../../models/assesment';


export const GetAssessmentDetailsApiAction = createAction('[AssessmentDetails] Get AssessmentDetails');
export const SuccessGetAssessmentDetailsApiAction =
  createAction('[AssessmentDetails] Success Get AssessmentDetails', props<{ assessmentDetails: IComplaince[] }>());
export const ErrorGetAssessmentDetailsApiAction =
  createAction('[AssessmentDetails] Error Get AssessmentDetails', props<Error>());
export const UpdateAssessmentDetailsApiAction =
  createAction('[AssessmentDetails] Update AssessmentDetails', props<{ payload: IComplaince[] }>());
